__turbopack_context__.v({
  "accordionSlideOverwrite": "select-module-scss-module__c164fq__accordionSlideOverwrite",
  "fadeIn": "select-module-scss-module__c164fq__fadeIn",
  "fadeOut": "select-module-scss-module__c164fq__fadeOut",
  "scaleIn": "select-module-scss-module__c164fq__scaleIn",
  "scaleOut": "select-module-scss-module__c164fq__scaleOut",
  "selectContent": "select-module-scss-module__c164fq__selectContent",
  "selectContentPopper": "select-module-scss-module__c164fq__selectContentPopper",
  "selectItem": "select-module-scss-module__c164fq__selectItem",
  "selectItemIndicator": "select-module-scss-module__c164fq__selectItemIndicator",
  "selectLabel": "select-module-scss-module__c164fq__selectLabel",
  "selectScrollDownButton": "select-module-scss-module__c164fq__selectScrollDownButton",
  "selectScrollUpButton": "select-module-scss-module__c164fq__selectScrollUpButton",
  "selectSeparator": "select-module-scss-module__c164fq__selectSeparator",
  "selectTrigger": "select-module-scss-module__c164fq__selectTrigger",
  "selectTriggerChip": "select-module-scss-module__c164fq__selectTriggerChip",
  "selectViewport": "select-module-scss-module__c164fq__selectViewport",
  "selectViewportPopper": "select-module-scss-module__c164fq__selectViewportPopper",
  "zoomIn": "select-module-scss-module__c164fq__zoomIn",
  "zoomOut": "select-module-scss-module__c164fq__zoomOut",
});
